import * as React from 'react'

import './TextAnswer.scss'

interface TextAnswerProps {
  name: string
  showLabel: boolean
  answerStyle: {
    answerFontColor: string
    answerFontSize: string
    answerFontFamily: {
      fontFamily: string
    }
    width: string
  }
}

const TextAnswer = (props: TextAnswerProps) => {
  const { name, showLabel, answerStyle } = props

  const textAnswerStyle = {
    color: answerStyle.answerFontColor,
    fontSize: answerStyle.answerFontSize,
    fontFamily: answerStyle.answerFontFamily?.fontFamily,
  }

  return (
    <React.Fragment>
      {showLabel && (
        <label style={textAnswerStyle} className="text-answer__label">
          {name}
        </label>
      )}
    </React.Fragment>
  )
}

export default TextAnswer
